<!--
@author: zhengzh
@date: 23.3.28
@description: 权限容器
props: {
  type: 'disabled', // String/权限类型/'disabled'
  remark: 'xxxx',   // String/权限码/
}
-->
<template>
  <template v-if="type !== 'disabled'">
    <div v-if="hasPermission">
      <slot></slot>
    </div>
  </template>


  <template v-if="type === 'disabled'">
    <div v-if="hasPermission">
      <slot></slot>
    </div>
    <div v-else class="disable">
      <div class="origin-element" @click.capture="(event) => disableEvent(event)"
        @mouseover.capture="(event) => disableEvent(event)" @mouseenter.capture="(event) => disableEvent(event)"
        @mousemove.capture="(event) => disableEvent(event)">
        <slot></slot>
      </div>
      <el-tooltip effect="light" content="没有权限" placement="top">
        <div class="mask-element"></div>
      </el-tooltip>
    </div>

  </template>


</template>


<script>
export default {
  name: 'Authority'
}
</script>

<script setup>
import { useUserStore } from '@/store/user';
import { ref, defineProps, watchEffect } from 'vue'


const props = defineProps({
  type: {
    type: String,
    default: 'disabled'
  },
  remark: {
    type: String,
    default: "",
  }
})

const disableEvent = (e) => {
  e.stopImmediatePropagation()
  e.stopPropagation();
  e.preventDefault()
}


const hasPermission = ref(false)
watchEffect(() => {
  const userStore = useUserStore()
  const getPermission = val => userStore.allAuthorities.includes(val)
  if (getPermission(props.remark)) {
    hasPermission.value = true
  } else {
    hasPermission.value = false
  }
})

</script>

<style lang="less" scoped>
.disable {
  position: relative;

  .mask-element {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    z-index: 99999;
  }

  :deep(*) {
    color: var(--api-disabled-color) !important;
    background: none !important;
    cursor: not-allowed !important;
    border: none;

    &:hover {
      color: var(--api-disabled-color) !important;
      background: none !important;
      cursor: not-allowed !important;
      border: none;

    }
  }
}
</style>
